const translation = {
  title: 'Досліджувати',
  sidebar: {
    discovery: 'Відкриття',
    chat: 'Чат',
    workspace: 'Робочий простір',
    action: {
      pin: 'Закріпити',
      unpin: 'Відкріпити',
      rename: 'Перейменувати',
      delete: 'Видалити',
    },
    delete: {
      title: 'Видалити додаток',
      content: 'Ви впевнені, що хочете видалити цю програму?',
    },
  },
  apps: {
    title: 'Вивчайте програми від Dify',
    description: 'Використовуйте ці шаблони миттєво або налаштуйте власні програми на основі шаблонів.',
    allCategories: 'Рекомендовані',
  },
  appCard: {
    addToWorkspace: 'Додати до робочого простору',
    customize: 'Налаштувати',
  },
  appCustomize: {
    title: 'Створити додаток з {{name}}',
    subTitle: 'Значок програми та назва',
    nameRequired: 'Назва програми обов’язкова',
  },
  category: {
    Assistant: 'Помічник',
    Writing: 'Написання',
    Translate: 'Переклад',
    Programming: 'Програмування',
    HR: 'HR',
    Workflow: 'Робочий процес',
    Agent: 'Агент',
    Entertainment: 'Розваги',
  },
}

export default translation
